import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getSortedTableData } from 'components/datatable/TableUtils'
import { getStationsHash } from 'utils/StationUtils'
import SieauAction from 'components/sieau/SieauAction'
import { isObject, keys } from 'lodash'
import { nbPerPageLabel } from 'referencial/constants/ReferencialConstants'
import { push } from '@lagunovsky/redux-react-router'
import { CardTable } from 'components/datatable/NewTable'

const DashboardStationsPanel = ({
    stationType,
    data = [],
    headers,
}) => {
    const dispatch = useDispatch()

    const {
        selectedSearchValues,
    } = useSelector(store => ({
        selectedSearchValues: store.AdministrationReducer.selectedSearchValues,
    }), shallowEqual)

    const [columnName, setColumnName] = useState()
    const [sort, setSort] = useState()

    const searchValues = selectedSearchValues[stationType]
    const initialSort = (searchValues && searchValues.columnName) && { column: searchValues.columnName, sort: searchValues.sort }

    const setSelectedSearchValueStations = useCallback(() => {
        const sortedStations = getSortedTableData(data.stations, { column: columnName, sort }, false)
        if (!searchValues || !searchValues.stations || getStationsHash(searchValues.stations) !== getStationsHash(sortedStations)) {
            dispatch(SieauAction.update('selectedSearchValues', stationType, { stations: sortedStations, columnName, sort }))
        }
    }, [columnName, data.stations, dispatch, searchValues, sort, stationType])

    useEffect(() => {
        setSelectedSearchValueStations()
    }, [sort, data, stationType, setSelectedSearchValueStations])

    const getColor = station => {
        if (station.color) return station.color
        if (isObject(station.closeDate)) {
            return station?.closeDate?.value ? 'grey' : 'white'
        }
        return station.closeDate ? 'grey' : 'white'
    }

    const tableStationsData = data.stations.map(station => {
        const color = getColor(station)
        return keys(station).reduce((acc, key) => {
            if (isObject(station[key])) {
                acc[key] = { ...station[key], color }
            } else {
                acc[key] = { value: station[key], color }
            }
            return acc
        }, {})
    })

    const actions = data.legendPanel ? [{
        icon: 'info_outlined',
        tooltip: data.legendPanel,
    }] : []

    return (
        <CardTable
            title={data.title}
            rows={tableStationsData}
            headers={headers}
            defaultSort={initialSort}
            actions={actions}
            rowsPerPageOptions={nbPerPageLabel}
            onSort={(newColumnName, newSort) => {
                setColumnName(newColumnName)
                setSort(newSort)
            }}
            onClickRow={s => dispatch(push(`/station/${stationType}/${s.id.value}`))}
            data-cy={stationType}
        />
    )
}

DashboardStationsPanel.propTypes = {
    stationType: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    headers: PropTypes.arrayOf(PropTypes.string),
}

export default DashboardStationsPanel